// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2546":"5edb4c8a","3078":"f31c5cef","4214":"366306e6","6054":"5edb4c8a","6402":"5edb4c8a","6589":"24580eec","6924":"5924713d","7155":"e65d80cc","7201":"9ab48984","8688":"27dd0431"}[chunkId] + ".chunk.css";
};